module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("短信任务")]), _vm._v(" "), (_vm.edit === false) ? _c('span', [_vm._v(" / 创建")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v(" / 编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "126px",
      "label-position": "left",
      "rules": _vm.rules,
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "当前人数："
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.maxCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称：",
      "prop": "name"
    }
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入任务名称"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入学年份：",
      "prop": "caid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择入学年份",
      "multiple": ""
    },
    model: {
      value: (_vm.formData.caid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "caid", $$v)
      },
      expression: "formData.caid"
    }
  }, _vm._l((_vm.inYearDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别标签：",
      "prop": "gender"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.formData.gender),
      callback: function($$v) {
        _vm.$set(_vm.formData, "gender", $$v)
      },
      expression: "formData.gender"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省份标签：",
      "prop": "provinces"
    }
  }, [_c('el-select', {
    staticClass: "multiple-select",
    attrs: {
      "placeholder": "请选择省份",
      "filterable": "",
      "multiple": ""
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.formData.provinces),
      callback: function($$v) {
        _vm.$set(_vm.formData, "provinces", $$v)
      },
      expression: "formData.provinces"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _vm._l((_vm.provinceList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": _vm.formData.provinces && _vm.formData.provinces.includes(-1)
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择人数",
      "prop": "sendCount"
    }
  }, [_c('div', {
    staticClass: "flex-row gap-20"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入人数"
    },
    on: {
      "input": _vm.handleSendCountInput
    },
    model: {
      value: (_vm.formData.sendCount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sendCount", $$v)
      },
      expression: "formData.sendCount"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getMaxCount
    }
  }, [_vm._v("查询人数")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编辑短信：",
      "prop": "editMessage"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入短信内容",
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "maxlength": 1000
    },
    model: {
      value: (_vm.formData.editMessage),
      callback: function($$v) {
        _vm.$set(_vm.formData, "editMessage", $$v)
      },
      expression: "formData.editMessage"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d0ede26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/MessageManage/SMSTask/SMSTaskEdit.vue
// module id = 1100
// module chunks = 0